<template>
  <div>
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-center" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-show="!loading">
      <div class="text-center">
        <img class="mb-3 logo" :src="logo">
      </div>
      <div class="user-info">
        <h2>Payment process</h2>
        <p>
          <strong>Client Name:</strong> {{info.clientFirstName}} {{info.clientLastName}}<br>
          <strong>Reservation:</strong> #{{info.reservationId}}<br>
          <strong>Total to pay:</strong> ${{info.total}} {{info.currency}}
        </p>
      </div>
      <div id="paypalcard"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PaypalPlus',
  props: {
  },
  data: () => {
    return {
      loadingPay: true,
      orderId:null,
      loadedPaypalBtn:false,
      info: {}
    }
  },
  mounted() {
    this.createOrder()
  },
  computed: {
    ...mapState(['hasSetting', 'settings','form','loadPaypalScript']),
    paypalClientId(){
      if(this.hasSetting){
        return this.settings.paymentTypes.find(pt => pt.code == 'card').publicKey
      }
      return ''
    },
    validLocale(){
      return this.$i18n.locale == 'es' ? 'es_MX' : 'en_US'
    },
    loading(){
      return this.loadingPay || !this.hasSetting
    },
    logo() {
      if (this.hasSetting) {
        return this.settings.logo;
      }
      return 'https://api.btransfer.mx/uploads/btransfer-logo.png';
    }
  },
  methods: {
    ...mapMutations(['setLoadPaypalScript','voucherToken']),
    createOrder(){
      this.loadingPay = true
      this.$http.get('payments/pcard', {params: {token: this.$route.query.token}}).then(res => {
        this.info = {...res.data}
        this.orderId = res.data.orderId
        this.tryLoadScript()
      })
    },
    tryLoadScript(){
      if (!this.loadPaypalScript && this.hasSetting) {
        let externalScript = document.createElement('script')
        externalScript.onload = () => {
          this.initPaypalBtn()
        }
        externalScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${this.paypalClientId}&currency=${this.info.currency}&locale=${this.validLocale}&components=buttons,funding-eligibility`)
        document.head.appendChild(externalScript)
        this.setLoadPaypalScript(true)
        this.loadingPay = false
      }
      else if (this.loadPaypalScript && !this.loadedPaypalBtn) {
        this.loadingPay = false
        this.initPaypalBtn()
      }
    },
    initPaypalBtn(){
      // Debit/Credit Card Button (black button)
      let bcdcButton = window.paypal.Buttons({
        style: {
          layout: "vertical"
        },
        fundingSource: window.paypal.FUNDING.CARD,
        createOrder: (data, actions) => {
          return this.orderId
        },
        onApprove: (data, actions) => {
          return actions.order.capture().then((details) => {
            this.updatePayment()
          });
        }
      });
      bcdcButton.render("#paypalcard");
      this.loadedPaypalBtn = true
    },
    updatePayment() {
      this.loadingPay = true
      this.$http.get('payments/update-ppayment', {
        params: { token: this.$route.query.token }
      }).then((res) => {
        if (res.body && res.body.success) {
          this.$router.push({path:'success',query: { token:this.$route.query.token }});
        }
      }).catch(() => {
          this.$router.push({path:'success',query: { token:this.$route.query.token }});
      });
    }
  },
  watch : {
    hasSetting : function(){
      this.tryLoadScript()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo{
		max-width: 200px;
  }

	.border{
		width: 100%;
		margin: 0 auto;
    border: 1px solid rgb(37, 36, 36);
    border-radius: 10px;
	}

  .user-info{
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .user-item{
    width: auto;
  }
</style>
<style>
  #ppplus iframe{
    width: 100% !important;
  }
</style>
